import React from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'
import {
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core'

class NoAlertsView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    text: PropTypes.string,
  }

  static defaultProps = {
    text: 'There are no alerts in your communities',
  }

  static styles = (theme) => ({
    paper: theme.mixins.gutters({
      paddingTop: theme.spacing(1),
      height: '100%',
    }),
    statusOk: {
      fontStyle: 'italic',
    },
  })

  render() {
    const { classes } = this.props

    return (
      <Paper className={classes.paper} elevation={0}>
        <Typography variant="h6">Alerts</Typography>
        <List>
          <ListItem>
            <ListItemText className={classes.statusOk} primary={this.props.text} />
          </ListItem>
        </List>
      </Paper>
    )
  }
}

export default withStyles(NoAlertsView.styles)(NoAlertsView)
